// Translations for English and Turkish
const translations = {
  en: {
    // Navigation
    dashboard: "Dashboard",
    units: "Apartments",
    tenants: "Tenants",
    contracts: "Contracts",
    reservations: "Reservations",
    accruals: "Accruals",
    payments: "Payments",
    reports: "Reports",
    maintenance: "Maintenance",
    documents: "Documents",
    settings: "Settings",
    bankAccounts: "Bank Accounts",
    properties: "Properties",
    buildings: "Buildings",
    tenantPortal: "Tenant Portal",
    
    // Common Actions
    addProperty: "Add Property",
    addBuilding: "Add Building",
    thisMonth: "This Month",
    next30Days: "Next 30 Days",
    noBuildings: "No buildings added yet",
    selectProperty: "Select Property",
    selectBuilding: "Select Building",
    selectUnit: "Select Apartment",
    selectTenant: "Select Tenant",
    floors: "Floors",
    
    // Currency
    currency: "$",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    createAccount: "Create Account",
    companyName: "Company Name",
    fullName: "Full Name",
    signInWithGoogle: "Sign in with Google",
    orContinueWith: "Or continue with",
    
    // Dashboard
    totalUnits: "Total Apartments",
    occupied: "Occupied",
    vacant: "Vacant",
    reserved: "Reserved",
    inMaintenance: "In Maintenance",
    monthlyRevenue: "Monthly Revenue",
    outstandingDebt: "Outstanding Debt",
    overduePayments: "Overdue Payments",
    contractsEndingSoon: "Contracts Ending Soon",
    upcomingCheckIns: "Upcoming Check-ins",
    recentPayments: "Recent Payments",
    openRequests: "Open Requests",
    
    // Units (Apartments)
    addUnit: "Add Apartment",
    editUnit: "Edit Apartment",
    unitName: "Apartment Name",
    duplicateUnit: "Duplicate",
    duplicateUnitTitle: "Duplicate Apartment",
    copyFromExisting: "Copy from existing apartment",
    selectApartment: "Select apartment to copy",
    duplicateCount: "Number of copies",
    status: "Status",
    monthlyRent: "Monthly Rent",
    dailyRent: "Daily Rent",
    waterFee: "Water Fee",
    internetFee: "Internet Fee",
    electricityType: "Electricity Type",
    prepaidMeter: "Prepaid Card Meter",
    regularMeter: "Regular Meter",
    floor: "Floor",
    sizeSqm: "Size (sqm)",
    notes: "Notes",
    inventory: "Inventory",
    photos: "Photos",
    
    // Tenants
    addTenant: "Add Tenant",
    editTenant: "Edit Tenant",
    tenantName: "Tenant Name",
    phone: "Phone",
    idPassport: "ID/Passport",
    address: "Address",
    emergencyContact: "Emergency Contact",
    
    // Contracts
    addContract: "Add Contract",
    editContract: "Edit Contract",
    startDate: "Start Date",
    endDate: "End Date",
    plannedMoveOut: "Planned Move-out",
    actualMoveOut: "Actual Move-out",
    active: "Active",
    movedOut: "Moved Out",
    terminated: "Terminated",
    cancelled: "Cancelled",
    deposit: "Deposit",
    depositAmount: "Deposit Amount",
    depositReceived: "Deposit Received",
    depositReturned: "Deposit Returned",
    deductionAmount: "Deduction Amount",
    dueDay: "Due Day",
    
    // Reservations
    addReservation: "Add Reservation",
    editReservation: "Edit Reservation",
    guestName: "Guest Name",
    guestPhone: "Guest Phone",
    guestEmail: "Guest Email",
    checkInDate: "Check-in Date",
    checkOutDate: "Check-out Date",
    totalAmount: "Total Amount",
    advancePayment: "Advance Payment",
    remainingBalance: "Remaining Balance",
    checkedIn: "Checked In",
    checkedOut: "Checked Out",
    
    // Accruals
    addAccrual: "Add Accrual",
    accrualType: "Accrual Type",
    rent: "Rent",
    water: "Water",
    internet: "Internet",
    extraCharge: "Extra Charge",
    discount: "Discount",
    amount: "Amount",
    paidAmount: "Paid Amount",
    remainingAmount: "Remaining",
    dueDate: "Due Date",
    unpaid: "Unpaid",
    partial: "Partial",
    paid: "Paid",
    overdue: "Overdue",
    
    // Payments
    addPayment: "Add Payment",
    paymentMethod: "Payment Method",
    cash: "Cash",
    bankTransfer: "Bank Transfer",
    card: "Card",
    manual: "Manual",
    paymentDate: "Payment Date",
    receipt: "Receipt",
    uploadReceipt: "Upload Receipt",
    
    // Maintenance
    addRequest: "Add Request",
    category: "Category",
    description: "Description",
    priority: "Priority",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    open: "Open",
    inProgress: "In Progress",
    resolved: "Resolved",
    assignedStaff: "Assigned Staff",
    
    // Bank Accounts
    addBankAccount: "Add Bank Account",
    bankName: "Bank Name",
    accountHolder: "Account Holder",
    iban: "IBAN",
    isActive: "Active",
    
    // Reports
    generateReport: "Generate Report",
    exportExcel: "Export Excel",
    exportPdf: "Export PDF",
    dateRange: "Date Range",
    filterBy: "Filter By",
    
    describeIssue: "Describe the issue in detail...",
    blocked: "Blocked",

    // Maintenance Categories
    plumbing: "Plumbing",
    electrical: "Electrical",
    hvac: "HVAC",
    appliance: "Appliance",
    structural: "Structural",
    other: "Other",
    selectCategory: "Select category",
    
    // Payment extras
    linkToAccrual: "Link to Accrual",
    selectAccrual: "Select accrual",
    totalReceived: "Total Received",
    totalPayments: "Total Payments",

    // Debt Tracking
    debtTracking: "Debt Tracking",
    generateAccruals: "Generate Accruals",
    accrualsGenerated: "Accruals generated",
    overdueTenants: "Overdue Tenants",
    totalDebt: "Total Debt",
    overdueCount: "Overdue",
    unpaidCount: "Unpaid",
    partialCount: "Partial",
    noDebt: "No outstanding debts",
    paymentStatus: "Payment Status",
    monthlyPayments: "Monthly Payments",
    contractPayments: "Contract Payments",
    tenantsWithDebt: "Tenants with Debt",
    viewDetails: "View Details",
    phone: "Phone",
    
    // Profile & User Management
    profile: "Profile",
    editProfile: "Edit Profile",
    currentPassword: "Current Password",
    newPassword: "New Password",
    profileUpdated: "Profile updated",
    userManagement: "User Management",
    addUser: "Add User",
    pendingApproval: "Pending Approval",
    approved: "Approved",
    rejected: "Rejected",
    approve: "Approve",
    reject: "Reject",
    createUser: "Create User",
    selectRole: "Select role",
    accountPendingApproval: "Your account is pending approval",
    noUsers: "No users found",

    // Aidat (Building Dues)
    dues: "Dues",
    duesTracking: "Dues Tracking",
    generateDues: "Generate Dues",
    monthlyDues: "Monthly Dues",
    duesGenerated: "Dues generated",
    totalDues: "Total Dues",
    paidDues: "Paid Dues",
    remainingDues: "Remaining Dues",
    noDues: "No dues found",
    aidat: "Dues",

    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    name: "Name",
    email: "E-mail",
    view: "View",
    search: "Search",
    filter: "Filter",
    actions: "Actions",
    loading: "Loading...",
    noData: "No data available",
    confirm: "Confirm",
    success: "Success",
    error: "Error",
    warning: "Warning",
    selectOption: "Select an option",
    required: "Required",
    optional: "Optional",
    all: "All",
    total: "Total",
    createdAt: "Created At",
    updatedAt: "Updated At",
    
    // Tenant Portal
    myContract: "My Contract",
    myPayments: "My Payments",
    myDebts: "My Debts",
    paymentInformation: "Payment Information",
    submitRequest: "Submit Request",
    announcements: "Announcements",
    
    // Validation
    invalidEmail: "Invalid email address",
    passwordTooShort: "Password must be at least 8 characters",
    passwordsDoNotMatch: "Passwords do not match",
    fieldRequired: "This field is required",
    
    // Messages
    loginSuccess: "Login successful",
    loginFailed: "Login failed",
    registerSuccess: "Registration successful",
    logoutSuccess: "Logged out successfully",
    saveSuccess: "Saved successfully",
    deleteSuccess: "Deleted successfully",
    errorOccurred: "An error occurred",
    confirmDelete: "Are you sure you want to delete this?",
    
    // Roles
    superAdmin: "Super Admin",
    companyAdmin: "Company Admin",
    finance: "Finance",
    operations: "Operations",
    maintenanceStaff: "Maintenance Staff",
    tenant: "Tenant",
  },
  
  tr: {
    // Navigation
    dashboard: "Kontrol Paneli",
    units: "Daireler",
    tenants: "Kiracılar",
    contracts: "Sözleşmeler",
    reservations: "Rezervasyonlar",
    accruals: "Tahakkuklar",
    payments: "Ödemeler",
    reports: "Raporlar",
    maintenance: "Bakım",
    documents: "Belgeler",
    settings: "Ayarlar",
    bankAccounts: "Banka Hesapları",
    properties: "Gayrimenkuller",
    buildings: "Binalar",
    tenantPortal: "Kiracı Portalı",
    
    // Common Actions
    addProperty: "Gayrimenkul Ekle",
    addBuilding: "Bina Ekle",
    thisMonth: "Bu Ay",
    next30Days: "Önümüzdeki 30 Gün",
    noBuildings: "Henüz bina eklenmedi",
    selectProperty: "Gayrimenkul Seçin",
    selectBuilding: "Bina Seçin",
    selectUnit: "Daire Seçin",
    selectTenant: "Kiracı Seçin",
    floors: "Kat Sayısı",
    
    // Currency
    currency: "TL",
    
    // Auth
    login: "Giriş Yap",
    register: "Kayıt Ol",
    logout: "Çıkış Yap",
    email: "E-posta",
    password: "Şifre",
    confirmPassword: "Şifreyi Onayla",
    forgotPassword: "Şifremi Unuttum",
    resetPassword: "Şifreyi Sıfırla",
    createAccount: "Hesap Oluştur",
    companyName: "Şirket Adı",
    fullName: "Ad Soyad",
    signInWithGoogle: "Google ile Giriş Yap",
    orContinueWith: "Veya devam et",
    
    // Dashboard
    totalUnits: "Toplam Daire",
    occupied: "Dolu",
    vacant: "Boş",
    reserved: "Rezerveli",
    inMaintenance: "Bakımda",
    monthlyRevenue: "Aylık Gelir",
    outstandingDebt: "Bekleyen Borç",
    overduePayments: "Gecikmiş Ödemeler",
    contractsEndingSoon: "Bitecek Sözleşmeler",
    upcomingCheckIns: "Yaklaşan Girişler",
    recentPayments: "Son Ödemeler",
    openRequests: "Açık Talepler",
    
    // Units (Daireler)
    addUnit: "Daire Ekle",
    editUnit: "Daireyi Düzenle",
    unitName: "Daire Adı",
    duplicateUnit: "Kopyala",
    duplicateUnitTitle: "Daire Kopyala",
    copyFromExisting: "Mevcut daireden kopyala",
    selectApartment: "Kopyalanacak daireyi seçin",
    duplicateCount: "Kopya sayısı",
    status: "Durum",
    monthlyRent: "Aylık Kira",
    dailyRent: "Günlük Kira",
    waterFee: "Su Ücreti",
    internetFee: "İnternet Ücreti",
    electricityType: "Elektrik Tipi",
    prepaidMeter: "Kartlı Sayaç",
    regularMeter: "Normal Sayaç",
    floor: "Kat",
    sizeSqm: "Boyut (m²)",
    notes: "Notlar",
    inventory: "Envanter",
    photos: "Fotoğraflar",
    
    // Tenants
    addTenant: "Kiracı Ekle",
    editTenant: "Kiracıyı Düzenle",
    tenantName: "Kiracı Adı",
    phone: "Telefon",
    idPassport: "Kimlik/Pasaport",
    address: "Adres",
    emergencyContact: "Acil Durum İletişimi",
    
    // Contracts
    addContract: "Sözleşme Ekle",
    editContract: "Sözleşmeyi Düzenle",
    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    plannedMoveOut: "Planlanan Taşınma",
    actualMoveOut: "Gerçek Taşınma",
    active: "Aktif",
    movedOut: "Taşındı",
    terminated: "Sonlandırıldı",
    cancelled: "İptal Edildi",
    deposit: "Depozito",
    depositAmount: "Depozito Tutarı",
    depositReceived: "Depozito Alındı",
    depositReturned: "Depozito İade Edildi",
    deductionAmount: "Kesinti Tutarı",
    dueDay: "Vade Günü",
    
    // Reservations
    addReservation: "Rezervasyon Ekle",
    editReservation: "Rezervasyonu Düzenle",
    guestName: "Misafir Adı",
    guestPhone: "Misafir Telefonu",
    guestEmail: "Misafir E-postası",
    checkInDate: "Giriş Tarihi",
    checkOutDate: "Çıkış Tarihi",
    totalAmount: "Toplam Tutar",
    advancePayment: "Avans Ödemesi",
    remainingBalance: "Kalan Bakiye",
    checkedIn: "Giriş Yapıldı",
    checkedOut: "Çıkış Yapıldı",
    
    // Accruals
    addAccrual: "Tahakkuk Ekle",
    accrualType: "Tahakkuk Tipi",
    rent: "Kira",
    water: "Su",
    internet: "İnternet",
    extraCharge: "Ek Ücret",
    discount: "İndirim",
    amount: "Tutar",
    paidAmount: "Ödenen Tutar",
    remainingAmount: "Kalan",
    dueDate: "Vade Tarihi",
    unpaid: "Ödenmedi",
    partial: "Kısmi",
    paid: "Ödendi",
    overdue: "Gecikmiş",
    
    // Payments
    addPayment: "Ödeme Ekle",
    paymentMethod: "Ödeme Yöntemi",
    cash: "Nakit",
    bankTransfer: "Banka Transferi",
    card: "Kart",
    manual: "Manuel",
    paymentDate: "Ödeme Tarihi",
    receipt: "Makbuz",
    uploadReceipt: "Makbuz Yükle",
    
    // Maintenance
    addRequest: "Talep Ekle",
    category: "Kategori",
    description: "Açıklama",
    priority: "Öncelik",
    low: "Düşük",
    medium: "Orta",
    high: "Yüksek",
    urgent: "Acil",
    open: "Açık",
    inProgress: "Devam Ediyor",
    resolved: "Çözüldü",
    assignedStaff: "Atanan Personel",
    
    // Bank Accounts
    addBankAccount: "Banka Hesabı Ekle",
    bankName: "Banka Adı",
    accountHolder: "Hesap Sahibi",
    iban: "IBAN",
    isActive: "Aktif",
    
    // Reports
    generateReport: "Rapor Oluştur",
    exportExcel: "Excel İndir",
    exportPdf: "PDF İndir",
    dateRange: "Tarih Aralığı",
    filterBy: "Filtrele",
    
    describeIssue: "Sorunu detaylı açıklayın...",
    blocked: "Engelli",

    // Maintenance Categories
    plumbing: "Tesisat",
    electrical: "Elektrik",
    hvac: "Klima/Isıtma",
    appliance: "Beyaz Eşya",
    structural: "Yapısal",
    other: "Diğer",
    selectCategory: "Kategori seçin",
    
    // Payment extras
    linkToAccrual: "Tahakkuk Bağla",
    selectAccrual: "Tahakkuk seçin",
    totalReceived: "Toplam Alınan",
    totalPayments: "Toplam Ödeme",

    // Debt Tracking
    debtTracking: "Borç Takip",
    generateAccruals: "Tahakkuk Oluştur",
    accrualsGenerated: "Tahakkuk oluşturuldu",
    overdueTenants: "Borçlu Kiracılar",
    totalDebt: "Toplam Borç",
    overdueCount: "Gecikmiş",
    unpaidCount: "Ödenmemiş",
    partialCount: "Kısmi",
    noDebt: "Borç bulunmuyor",
    paymentStatus: "Ödeme Durumu",
    monthlyPayments: "Aylık Ödemeler",
    contractPayments: "Sözleşme Ödemeleri",
    tenantsWithDebt: "Borçlu Kiracı",
    viewDetails: "Detay Gör",
    
    // Profile & User Management
    profile: "Profil",
    editProfile: "Profili Düzenle",
    currentPassword: "Mevcut Şifre",
    newPassword: "Yeni Şifre",
    profileUpdated: "Profil güncellendi",
    userManagement: "Kullanıcı Yönetimi",
    addUser: "Kullanıcı Ekle",
    pendingApproval: "Onay Bekliyor",
    approved: "Onaylı",
    rejected: "Reddedildi",
    approve: "Onayla",
    reject: "Reddet",
    createUser: "Kullanıcı Oluştur",
    selectRole: "Rol seçin",
    accountPendingApproval: "Hesabınız onay bekliyor",
    noUsers: "Kullanıcı bulunamadı",

    // Aidat (Building Dues)
    dues: "Aidat",
    duesTracking: "Aidat Takip",
    generateDues: "Aidat Oluştur",
    monthlyDues: "Aylık Aidat",
    duesGenerated: "Aidat oluşturuldu",
    totalDues: "Toplam Aidat",
    paidDues: "Ödenen Aidat",
    remainingDues: "Kalan Aidat",
    noDues: "Aidat kaydı bulunamadı",
    aidat: "Aidat",

    // Common
    save: "Kaydet",
    cancel: "İptal",
    delete: "Sil",
    edit: "Düzenle",
    name: "Ad Soyad",
    email: "E-posta",
    view: "Görüntüle",
    search: "Ara",
    filter: "Filtre",
    actions: "İşlemler",
    loading: "Yükleniyor...",
    noData: "Veri bulunamadı",
    confirm: "Onayla",
    success: "Başarılı",
    error: "Hata",
    warning: "Uyarı",
    selectOption: "Seçenek seçin",
    required: "Zorunlu",
    optional: "İsteğe Bağlı",
    all: "Tümü",
    total: "Toplam",
    createdAt: "Oluşturulma Tarihi",
    updatedAt: "Güncellenme Tarihi",
    
    // Tenant Portal
    myContract: "Sözleşmem",
    myPayments: "Ödemelerim",
    myDebts: "Borçlarım",
    paymentInformation: "Ödeme Bilgileri",
    submitRequest: "Talep Gönder",
    announcements: "Duyurular",
    
    // Validation
    invalidEmail: "Geçersiz e-posta adresi",
    passwordTooShort: "Şifre en az 8 karakter olmalıdır",
    passwordsDoNotMatch: "Şifreler eşleşmiyor",
    fieldRequired: "Bu alan zorunludur",
    
    // Messages
    loginSuccess: "Giriş başarılı",
    loginFailed: "Giriş başarısız",
    registerSuccess: "Kayıt başarılı",
    logoutSuccess: "Çıkış yapıldı",
    saveSuccess: "Kaydedildi",
    deleteSuccess: "Silindi",
    errorOccurred: "Bir hata oluştu",
    confirmDelete: "Silmek istediğinizden emin misiniz?",
    
    // Roles
    superAdmin: "Süper Yönetici",
    companyAdmin: "Şirket Yöneticisi",
    finance: "Finans",
    operations: "Operasyon",
    maintenanceStaff: "Bakım Personeli",
    tenant: "Kiracı",
  }
};

export default translations;
